import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Markdown from 'react-markdown';
import { getInsightById, categories } from '../../data/insights';
import './Insights.css';

const InsightsDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const post = getInsightById(id);

    useEffect(() => {
        // Scroll to top on mount
        window.scrollTo(0, 0);
    }, [id]);

    if (!post) {
        return (
            <div className="insights-container" style={{ textAlign: 'center', padding: '10rem 0' }}>
                <h2>콘텐츠를 찾을 수 없습니다.</h2>
                <button
                    onClick={() => navigate('/insights')}
                    className="category-btn active"
                    style={{ marginTop: '2rem' }}
                >
                    목록으로 돌아가기
                </button>
            </div>
        );
    }

    const categoryName = categories.find(c => c.id === post.category)?.name;

    return (
        <div className="insight-detail-container">
            <Helmet>
                <title>{post.title} | StartUs Insights</title>
                <meta name="description" content={post.summary} />
                <meta property="og:title" content={post.title} />
                <meta property="og:description" content={post.summary} />
                <meta property="og:image" content={post.thumbnail} />
                <meta property="og:type" content="article" />
            </Helmet>

            <header className="detail-header">
                <span className="detail-category">{categoryName}</span>
                <h1 className="detail-title">{post.title}</h1>
                <div className="detail-meta">
                    <span>{post.date}</span>
                </div>
            </header>

            <img
                src={post.thumbnail}
                alt={post.title}
                className="detail-thumb"
                onError={(e) => {
                    e.target.src = 'https://placehold.co/800x450/f5f5f5/cccccc?text=StartUs';
                }}
            />

            <article className="markdown-content">
                <Markdown>{post.content}</Markdown>
            </article>

            <div style={{ marginTop: '4rem', textAlign: 'center', borderTop: '1px solid #eee', paddingTop: '3rem' }}>
                <button
                    onClick={() => navigate('/insights')}
                    className="category-btn"
                >
                    목록으로 돌아가기
                </button>
            </div>
        </div>
    );
};

export default InsightsDetail;
